"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeInstructionVideoBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var journey_model_1 = require("@athena-portal/journey-model");
var YoutubeInstructionVideoBannerWidget = /** @class */ (function (_super) {
    __extends(YoutubeInstructionVideoBannerWidget, _super);
    function YoutubeInstructionVideoBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.bannerText = undefined;
        _this.modalSettings = undefined;
        _this.state = {
            shouldShowPopup: false
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        return _this;
    }
    YoutubeInstructionVideoBannerWidget.prototype.componentDidMount = function () {
        this.validateSettings();
    };
    YoutubeInstructionVideoBannerWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-button-panel font-weight-light banner d-flex flex-row how-to-video-banner", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-button cursor-pointer" }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex flex-column", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { children: this.bannerText }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("button", { type: "button", className: "btn-link text-decoration-underline d-block border-0 bg-transparent", onClick: this.toggleModal, children: [(0, jsx_runtime_1.jsx)("span", { className: "fa fa-solid fa-play" }), "\u00A0 Play video"] }) })] })] }), this.state.shouldShowPopup && this.renderPopup()] }));
    };
    YoutubeInstructionVideoBannerWidget.prototype.renderPopup = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggleModal });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.shouldShowPopup, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggleModal, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex flex-row how-to-video-popup-header", children: [(0, jsx_runtime_1.jsx)("img", { alt: "info-icon", src: "/img/info-icon-active.svg", height: 35 }), (0, jsx_runtime_1.jsx)("h1", { className: "ml-1", children: this.modalSettings.title })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("iframe", { className: "how-to-video", src: this.modalSettings.videoUrl, title: "YouTube video player", loading: "lazy", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerPolicy: "strict-origin-when-cross-origin", allowFullScreen: true }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { className: "btn btn-primary", type: "button", onClick: this.toggleModal, children: "Ok, thanks" }) })] }));
    };
    YoutubeInstructionVideoBannerWidget.prototype.toggleModal = function () {
        this.setState({ shouldShowPopup: !this.state.shouldShowPopup });
    };
    YoutubeInstructionVideoBannerWidget.prototype.validateSettings = function () {
        var _a, _b;
        this.bannerText = this.getSetting("bannerText");
        if (!this.bannerText) {
            throw new Error("Setting 'bannerText' should be provided!");
        }
        this.modalSettings = this.getSetting("modalSettings");
        if (!this.modalSettings) {
            throw new Error("Setting 'modalSettings' should be provided!");
        }
        else if (!((_a = this.modalSettings) === null || _a === void 0 ? void 0 : _a.title)) {
            throw new Error("Setting 'modalSettings.title' should be provided!");
        }
        else if (!((_b = this.modalSettings) === null || _b === void 0 ? void 0 : _b.videoUrl)) {
            throw new Error("Setting 'modalSettings.videoUrl' should be provided!");
        }
    };
    YoutubeInstructionVideoBannerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "bannerText", type: journey_model_1.TypeDescriptions.String },
            { name: "modalSettings", type: journey_model_1.TypeDescriptions.Object }
        ]),
        __metadata("design:paramtypes", [Object])
    ], YoutubeInstructionVideoBannerWidget);
    return YoutubeInstructionVideoBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.YoutubeInstructionVideoBannerWidget = YoutubeInstructionVideoBannerWidget;
//# sourceMappingURL=YoutubeInstructionVideoBannerWidget.js.map